import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiEndpoint } from '@shared/shared/enums/api-endpoints.enum';
import { LanguageService } from '@shared/shared/services/language-service';
import { replaceTemplateKeys } from '@shared/utils/url.lib';
import { map, switchMap } from 'rxjs/operators';
import * as fromActions from '../actions/hotel-amenities.actions';

@Injectable()
export class HotelAmenitiesEffects {
  constructor(private actions$: Actions, private languageService: LanguageService, private http: HttpClient) {}

  public getHotelAmenities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromActions.GET_HOTEL_AMENITIES),
      switchMap(() => {
        const url = replaceTemplateKeys(ApiEndpoint.TRAVEL_HOTEL_AMENITIES, {
          locale: this.languageService.currentLanguage,
        });

        return this.http.get(url).pipe(
          map((data) => {
            return new fromActions.GetHotelAmenitiesSuccess(data);
          })
        );
      })
    )
  );
}
